export default "__VITE_ASSET__BETEXmZS__"